<template>
  <v-row>
    <v-dialog
      transition="scale-transition"
      persistent
      :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '1100px'"
      v-model="component.dialog_finish"
    >
      <v-card class="mx-auto" outlined>
        <v-container :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : ''">
          <v-row>
            <v-spacer></v-spacer>
            <v-icon left class="mt-2" @click="close">mdi-close</v-icon>
          </v-row>

          <v-row class="ml-2 mb-2">
            <v-card-title :class="$vuetify.breakpoint.xsOnly ? 'text-h6' : ''"
              >Finalização de Venda</v-card-title
            >
          </v-row>

          <v-divider></v-divider>

          <v-card-text>
            <v-row
              justify="center"
              :class="$vuetify.breakpoint.xsOnly ? 'ml-0' : 'ml-14'"
            >
              <v-col
                :cols="$vuetify.breakpoint.xsOnly ? '6' : '3'"
                class="titleValue primary--text"
              >
                Valor pago
                <v-row justify="center" class="valueFinal">
                  <v-col>R$ {{ total_pay }}</v-col>
                </v-row>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.xsOnly ? '6' : '3'"
                class="titleValue red--text"
              >
                Valor restante
                <v-row justify="center" class="valueFinal">
                  <v-col>R$ {{ total_remain.toFixed(2) }}</v-col>
                </v-row>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.xsOnly ? '6' : '3'"
                class="titleValue"
              >
                Valor Troco
                <v-row justify="center" class="valueFinal">
                  <v-col>R$ {{ total_change.toFixed(2) }}</v-col>
                </v-row>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.xsOnly ? '6' : '3'"
                class="titleValue"
              >
                Valor final
                <v-row justify="center" class="valueFinal">
                  <v-col>R$ {{ finalValueWithAdjustments.toFixed(2) }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-form ref="form" v-model="validRegister" class="mt-5">
            <v-row :class="$vuetify.breakpoint.xsOnly ? 'ma-0' : 'ml-2'">
              <v-col
                :cols="$vuetify.breakpoint.xsOnly ? '12' : '3'"
                :class="$vuetify.breakpoint.xsOnly ? '' : 'ml-2'"
              >
                <v-select
                  label="Forma"
                  :items="items_formPay"
                  v-model="form_of_payments.form"
                  item-value="id"
                  item-text="description"
                  :rules="rules"
                  return-object
                  outlined
                  :dense="$vuetify.breakpoint.xsOnly"
                ></v-select>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '3'">
                <v-select
                  return-object
                  label="Condição"
                  :disabled="validCondition"
                  :items="items_payTerm"
                  v-model="form_of_payments.condition"
                  item-value="id"
                  :rules="rules"
                  outlined
                  :dense="$vuetify.breakpoint.xsOnly"
                >
                  <template v-slot:selection="{ item }">
                    {{ getConditionLabel(item) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ getConditionLabel(item) }}
                  </template>
                </v-select>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '2'">
                <v-text-field
                  label="Valor"
                  :disabled="validValue"
                  v-model="form_of_payments.value_form_payment"
                  outlined
                  :rules="rules"
                  prefix="R$"
                  :dense="$vuetify.breakpoint.xsOnly"
                ></v-text-field>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : 'auto'">
                <v-btn
                  :block="$vuetify.breakpoint.xsOnly"
                  :class="$vuetify.breakpoint.xsOnly ? '' : 'ml-4'"
                  color="success"
                  :disabled="total_remain.toFixed(2) == 0"
                  @click="register()"
                  >Registrar</v-btn
                >
              </v-col>
            </v-row>

            <v-row
              v-if="currentAdjustment"
              :class="$vuetify.breakpoint.xsOnly ? 'ma-0 mt-2' : 'ml-2 mt-2'"
            >
              <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '8'">
                <v-alert
                  :type="
                    currentAdjustment.type === 'DISCOUNT' ? 'success' : 'info'
                  "
                  dense
                  text
                  :class="$vuetify.breakpoint.xsOnly ? 'text-caption' : ''"
                >
                  <strong>{{
                    currentAdjustment.type === "DISCOUNT"
                      ? "Desconto"
                      : "Acréscimo"
                  }}</strong>
                  de
                  <strong>{{
                    currentAdjustment.adjustment_type === "PERCENT"
                      ? currentAdjustment.value + "%"
                      : "R$ " + currentAdjustment.value
                  }}</strong>
                  aplicado. Valor original: R$
                  {{ currentAdjustment.originalValue }} | Valor final: R$
                  {{ currentAdjustment.finalValue }}
                </v-alert>
              </v-col>
            </v-row>
          </v-form>

          <v-divider></v-divider>

          <v-row justify="center">
            <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '11'">
              <v-data-table
                hide-default-footer
                :headers="headers"
                :items="table"
                no-data-text="Sem registros"
                :dense="$vuetify.breakpoint.xsOnly"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="red darken-3"
                    class="ml-2"
                    @click="deleteItem(item)"
                    >mdi-delete</v-icon
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="mx-2 mb-2" align="center">
            <v-col cols="auto">
              <span class="text-caption font-weight-bold"
                >Tipo de Emissão:</span
              >
            </v-col>
            <v-col cols="auto">
              <v-btn-toggle v-model="invoiceType" mandatory dense>
                <v-btn
                  :value="INVOICE_TYPE.NFCE"
                  small
                  :color="invoiceType === INVOICE_TYPE.NFCE ? 'primary' : ''"
                  :disabled="!nfceNoteModel"
                  style="min-width:auto;padding:0 10px"
                >NFC-e</v-btn>
                <v-btn
                  v-if="isLegalPeopleClient"
                  :value="INVOICE_TYPE.NFE"
                  small
                  :color="invoiceType === INVOICE_TYPE.NFE ? 'primary' : ''"
                  :disabled="!nfeNoteModel"
                  style="min-width:auto;padding:0 10px"
                  >NF-e</v-btn
                >
                <v-btn
                  :value="INVOICE_TYPE.ORCAMENTO"
                  small
                  :color="invoiceType === INVOICE_TYPE.ORCAMENTO ? 'orange darken-2' : ''"
                  :disabled="!orcNoteModel"
                  style="min-width:auto;padding:0 10px"
                  >{{
                    orcNoteModel ? orcNoteModel.description : "Orçamento"
                  }}</v-btn
                >
              </v-btn-toggle>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn
              block
              :loading="isloading"
              class="success"
              @click="dialogConfirm = true"
              :disabled="
                total_pay != finalValueWithAdjustments.toFixed(2) || isloading
              "
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- Dialog de confirmação de finalização -->
    <v-dialog v-model="dialogConfirm" max-width="440" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon class="mr-2" :color="confirmIconColor">{{ confirmIcon }}</v-icon>
          Confirmar {{ confirmTypeLabel }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-simple-table dense>
            <tbody>
              <tr>
                <td class="grey--text text--darken-1">Tipo</td>
                <td><v-chip small :color="confirmIconColor" dark>{{ confirmTypeLabel }}</v-chip></td>
              </tr>
              <tr>
                <td class="grey--text text--darken-1">Cliente</td>
                <td>{{ component.sale && component.sale.client && component.sale.client.physicalpeople
                      ? component.sale.client.physicalpeople.name
                      : (component.sale && component.sale.client && component.sale.client.legalpeople
                        ? component.sale.client.legalpeople.fantasyName : '-') }}</td>
              </tr>
              <tr>
                <td class="grey--text text--darken-1">Itens</td>
                <td>{{ getCart.length }} {{ getCart.length === 1 ? 'item' : 'itens' }}</td>
              </tr>
              <tr v-for="(pay, i) in table" :key="i">
                <td class="grey--text text--darken-1">{{ pay.form && pay.form.description }}</td>
                <td>R$ {{ parseFloat(pay.value_form_payment).toFixed(2) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total</td>
                <td class="font-weight-bold green--text text--darken-2">R$ {{ finalValueWithAdjustments.toFixed(2) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogConfirm = false">Cancelar</v-btn>
          <v-btn :color="confirmIconColor" dark @click="onConfirmFinalize">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PrintSaleDialog :component="this" v-if="dialogPermissionPrint" />
    <dialogExchangeCredit v-if="exchangeDialog" :component="this" />
    <loadSale
      v-if="dialog_load"
      :component="this"
      :status="status"
      :title="title"
      :activeTime="activeTime"
      :time="time"
    />
    <ModalError
      v-if="dialog_alert"
      :component="this"
      :title_error="titleError"
      :listErrors="listErrors"
    />
    <NsuConfig :component="this" />
    <PrintNfce v-if="dialog_nfce" :component="this" />
  </v-row>
</template>

<script>
import { headers } from "./script";
import { FORM_OF_PAYMENT_CODE } from "@/enums/formOfPaymentCode";
import {
  formatDateForDatabase,
  formatDateForISO,
  formatDateTimeForDatabase,
} from "@/utils/formatters";
import { GET_ALL_FORM_OF_PAYMENT } from "@/store/actions/formofpayment";
import { GET_ALL_PAYMENT_TERM } from "@/store/actions/paymentterm";
import { GET_ALL_PRODUCT_BY_STATUS } from "@/store/actions/product";

import { mapGetters } from "vuex";
import loadSale from "../Load_Sale/";
import PrintSaleDialog from "../Confirm_Print_Note/";
import dialogExchangeCredit from "../dialogExchangeCredit/";
import {
  ADD_SALES_WITH_UPDATE_SEQUENCE,
  CLEAN_CART,
  UPDATE_SALES,
  SEARCH_COUPON,
  DOWNLOAD_CREDIT,
} from "@/store/actions/sales";
import { GET_TAX_PRODUCT_IBPT } from "@/store/actions/ibpt";
import { ISSUE_OF_INVOICE_NFCE, GET_SEQUENCE_NFCE, GET_NOTE_MODELS_BY_PDV } from "@/store/actions/nfce";
import { ISSUE_OF_INVOICE_NFE } from "@/store/actions/nfe";
import NsuConfig from "../Nsu_inf_card/index.vue";
import ModalError from "../Modal_Error/";
import PrintNfce from "../PrintNfce/index.vue";
import {
  ACTIVE_CONTIGENCY,
  DESATIVE_CONTIGENCY_NFCE,
} from "@/store/actions/contigency";
import { REDEEM_LOYALTY_POINTS } from "@/store/actions/loyalty";
import axiosautomacao from "@/apigestao";
import { INVOICE_TYPE, NOTE_MODEL_TYPE } from "@/enums/invoiceType";
const IcmsSimplesService = require("@/Domain/Service/Tribute/IcmsSimplesNacionalTotalService");

export default {
  components: {
    loadSale,
    ModalError,
    NsuConfig,
    PrintNfce,
    dialogExchangeCredit,
    PrintSaleDialog,
  },
  props: {
    component: Object,
  },
  data: () => ({
    FORM_OF_PAYMENT_CODE,
    activeTime: false,
    nsuConfigShow: Boolean(false),
    items_formPay: Array(),
    items_payTerm: Array(),
    validCondition: Boolean(),
    validValue: Boolean(),
    validRegister: Boolean(),
    headers,
    dialog_load: Boolean(),
    dialog_alert: Boolean(),
    dialog_nfce: Boolean(),
    titleError: String(),
    listErrors: Array(),
    nfcePrint: String(),
    title: String(),
    addSalesProcess: false,
    INVOICE_TYPE,
    invoiceType: INVOICE_TYPE.NFCE,
    nfceNoteModel: null,
    nfeNoteModel: null,
    orcNoteModel: null,
    dialogConfirm: false,
    table: Array(),
    total_pay: Number(),
    total_remain: Number(),
    total_change: Number(),
    value_form_payment: Number(),
    new_pay: Object(),

    infCard: Object(),

    form_of_payments: {
      code: String(),
      form: String(),
      condition: String(),
      value_form_payment: null,
    },
    billstoReceive: Array(),
    isloading: false,
    statusNfce: ["Emitindo Nota SEFAZ", "Salvando Nota", "Imprimindo Nota"],
    rules: [(v) => !!v || "Campo obrigatório"],
    exchangeDialog: Boolean(),
    codeCupomSearch: String(),
    dialogPermissionPrint: false,
    saleSuccess: false,
    idCreditExchange: Number(),
    pendingCreditoPay: null,
    time: Number(),
    contador: Number(),
    currentAdjustment: null,
    totalAdjustments: 0,
  }),
  methods: {
    searchCupom() {
      const payload = {
        number_title: this.codeCupomSearch,
        enterprise_id: this.component.sale.enterprise_id,
        cliente_id: this.component.sale.client_id,
        type_title: "CT",
      };
      return this.$store.dispatch(SEARCH_COUPON, payload).then((response) => {
        const creditAvailable = parseFloat(response.data.value_exchange);
        const valueRequested = this.pendingCreditoPay
          ? parseFloat(this.pendingCreditoPay.value_form_payment)
          : 0;
        if (valueRequested > creditAvailable) {
          throw new Error(
            `Valor informado (R$ ${valueRequested.toFixed(
              2
            )}) excede o crédito disponível (R$ ${creditAvailable.toFixed(2)})`
          );
        }
        this.idCreditExchange = response.data.billstopay_id;
        this.exchangeDialog = false;
        if (this.pendingCreditoPay) {
          if (
            this.currentAdjustment &&
            this.currentAdjustment.calculatedValue
          ) {
            this.totalAdjustments += this.currentAdjustment.calculatedValue;
            this.pendingCreditoPay.adjustmentValue =
              this.currentAdjustment.calculatedValue;
          }
          this.table.push(this.pendingCreditoPay);
          this.pendingCreditoPay = null;
          this.new_pay = {};
          this.currentAdjustment = null;
        }
      });
    },
    confirmInfCard() {
      const infCard = this.infCard;
      this.new_pay = { ...infCard };
      this.nsuConfigShow = !this.nsuConfigShow;
    },
    close() {
      if (this.dialogPermissionPrint) {
        this.component.dialogPermissionPrint = false;
      }
      this.component.dialog_finish = !this.component.dialog_finish;
      this.table = [];
      this.total_remain = 0;
      this.currentAdjustment = null;
      this.totalAdjustments = 0;
      this.invoiceType = INVOICE_TYPE.NFCE;
    },
    value_pay(items) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      let variable = items.map((e) => e.value_form_payment);
      this.total_pay = variable.reduce(reducer, 0).toFixed(2);
    },
    value_remain() {
      let total = this.finalValueWithAdjustments - this.total_pay;
      if (total < 0) {
        this.total_change = Math.abs(total);
        this.total_remain = 0;
      } else {
        this.total_remain = total;
        this.total_change = 0;
      }
    },
    register() {
      const { DINHEIRO, CARTAO_CREDITO, CARTAO_DEBITO, CREDITO_LOJA } =
        this.FORM_OF_PAYMENT_CODE;
      let validate = this.$refs.form.validate();
      if (validate) {
        this.new_pay = { ...this.form_of_payments };
        this.new_pay.value_form_payment = parseFloat(
          this.new_pay.value_form_payment
        );
        this.form_of_payments.form.description.replace(/\s/g, "").toLowerCase();

        if (this.new_pay.form.code == CREDITO_LOJA) {
          if (this.new_pay.value_form_payment > this.total_remain) {
            alert("Valor registrado acima do valor restante");
            return;
          }
          this.pendingCreditoPay = { ...this.new_pay };
          this.exchangeDialog = true;
          return;
        }

        if (this.new_pay.form.code != DINHEIRO) {
          if (this.new_pay.value_form_payment > this.total_remain.toFixed(2)) {
            alert("Valor registrado acima do valor restante");
          } else {
            if (
              this.currentAdjustment &&
              this.currentAdjustment.calculatedValue
            ) {
              this.totalAdjustments += this.currentAdjustment.calculatedValue;
              this.new_pay.adjustmentValue =
                this.currentAdjustment.calculatedValue;
            }
            this.table.push(this.new_pay);
            if (
              this.new_pay.form.code == CARTAO_CREDITO ||
              this.new_pay.form.code == CARTAO_DEBITO
            ) {
              this.nsuConfigShow = !this.nsuConfigShow;
            }
          }
        } else if (this.new_pay.form.code == DINHEIRO) {
          if (
            this.currentAdjustment &&
            this.currentAdjustment.calculatedValue
          ) {
            this.totalAdjustments += this.currentAdjustment.calculatedValue;
            this.new_pay.adjustmentValue =
              this.currentAdjustment.calculatedValue;
          }
          this.table.push(this.new_pay);
        }
        this.new_pay = {};
        this.currentAdjustment = null;
      }
    },
    deleteItem(item) {
      if (item.adjustmentValue) {
        this.totalAdjustments -= item.adjustmentValue;
      }
      this.table.splice(this.table.indexOf(item), 1);
    },
    calc_value_tribute_itens(val, key) {
      const total = val
        .map((e) => {
          const value = parseFloat(e?.[key]);
          return isNaN(value) ? 0 : value;
        })
        .reduce((acc, curr) => acc + curr, 0);

      return Number(total.toFixed(2));
    },

    async calcIbptTotalNfce(itensVenda) {
      let valueAproximateTributeTotal = 0;
      itensVenda.forEach((itemProduct) => {
        valueAproximateTributeTotal =
          parseFloat(valueAproximateTributeTotal) +
          parseFloat(itemProduct.valueOfApproximateTax);
      });
      this.component.sale.valueApproximateTax = valueAproximateTributeTotal;
    },

    async calcIbptProductsItens(itensVenda) {
      let valueAproximeTaxNational = 0;
      let valueAproximeTaxState = 0;
      let itensProductResultApiIbpt = {};
      let valueItemProductTaxAprox = 0;
      let itensSalesIbpt = this.mounterValueCalcIbpt(itensVenda);
      await this.$store
        .dispatch(GET_TAX_PRODUCT_IBPT, {
          cnpjEmitter: this.getEnterprises.data[0].cnpj,
          listProducts: itensSalesIbpt,
        })
        .then((data) => {
          itensProductResultApiIbpt = data.response.data.ibptTaxProducts;
          itensVenda.forEach((itemProduct) => {
            itensProductResultApiIbpt.forEach((itemResultApi) => {
              if (String(itemProduct.ncmProduct) === itemResultApi.code_tax) {
                valueAproximeTaxNational =
                  itemProduct.value_sale * (itemResultApi.tax_national / 100);
                valueAproximeTaxState =
                  itemProduct.value_sale * (itemResultApi.tax_state / 100);
                valueItemProductTaxAprox =
                  parseFloat(valueAproximeTaxNational) +
                  parseFloat(valueAproximeTaxState);
                itemProduct.valueOfApproximateTax =
                  valueItemProductTaxAprox.toFixed(2);
              }
            });
          });
        })
        .catch((error) => {
          this.calcIbptProductsIfExceptionErrorApi(itensVenda);
        });
    },
    calcIbptProductsIfExceptionErrorApi(itensVenda) {
      const nacionalTax = 7.85 / 100;
      const stateTax = 17 / 100;
      let valueTotalTaxAproxDefault = 0;
      let valueCalcNacional = 0;
      let valueStateTax = 0;
      let valueTaxProduct = 0;
      itensVenda.forEach((itemProduct) => {
        valueCalcNacional = itemProduct.value_sale * nacionalTax;
        valueStateTax = itemProduct.value_sale * stateTax;
        valueTaxProduct =
          parseFloat(valueCalcNacional) + parseFloat(valueStateTax);
        itemProduct.valueOfApproximateTax = valueTaxProduct.toFixed(2);
        valueTotalTaxAproxDefault =
          valueTotalTaxAproxDefault + valueCalcNacional + valueStateTax;
      });
      this.component.sale.valueApproximateTax =
        valueTotalTaxAproxDefault.toFixed(2);
    },

    mounterValueCalcIbpt(itensVenda) {
      let listProductIbpt = [];
      let productIbpt = {};

      itensVenda.forEach((item) => {
        productIbpt = {
          code_tax: String(item.ncmProduct),
          uf_operation: "ES",
          extarif: 0,
          code_product: String(item.product_id),
          description_product: item.description,
          unit_product: item.product.unit.sigla,
          valor_product: item.value_sale,
          gtin: this.checkGetin(item.product.bar_code),
        };
        listProductIbpt.push(productIbpt);
      });
      return listProductIbpt;
    },
    checkGetin(eanProduct) {
      if (eanProduct === null || eanProduct === "") {
        return "SEM GTIN";
      }
      return eanProduct;
    },

    async calc_tribute_finish_sale() {
      let itens_venda = this.getCart;
      await this.calcIbptProductsItens(itens_venda);
      await this.calcIbptTotalNfce(itens_venda);
      try {
        if (itens_venda.length !== 0) {
          this.component.sale.value_total_products =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_subtotal_product"
            );
          this.component.sale.value_total_note = this.calc_value_tribute_itens(
            itens_venda,
            "value_sale"
          );
          this.component.sale.value_account_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_accounting_product"
            );
          this.component.sale.value_descount_total =
            this.calc_value_tribute_itens(itens_venda, "value_descont_product");

          const loyaltyDiscount =
            this.component.sale.loyalty_discount ||
            this.component.loyaltyDiscount ||
            0;
          if (loyaltyDiscount > 0) {
            this.component.sale.value_descount_total = (
              parseFloat(this.component.sale.value_descount_total) +
              parseFloat(loyaltyDiscount)
            ).toFixed(2);
          }

          const enterprise = this.getEnterprises.data[0];
          this.component.sale.base_cal_icms_total =
            IcmsSimplesService.calculateBaseIcmsTotal(itens_venda, enterprise);
          this.component.sale.value_icms_free_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_free_icms_product"
            );
          this.component.sale.value_outher_tax_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_icms_outher_product"
            );
          this.component.sale.base_calc_susbt_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_icms_st_product"
            );
          this.component.sale.value_icms_substituicao_total =
            this.calc_value_tribute_itens(itens_venda, "value_icms_st_product");
          this.component.sale.value_ipi_total = this.calc_value_tribute_itens(
            itens_venda,
            "value_ipi_product"
          );
          this.component.sale.value_ipi_outher_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_ipi_outher_product"
            );
          this.component.sale.value_ipi_free_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_ipi_free_product"
            );
          this.component.sale.base_calc_ipi_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_ipi_product"
            );
          this.component.sale.value_base_pis_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_pis_product"
            );
          this.component.sale.value_base_pis_st_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_pis_st_product"
            );
          this.component.sale.value_base_cofins_st_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_cofins_st_product"
            );
          this.component.sale.value_base_cofins_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_cofins_product"
            );
          this.component.sale.value_other_pis_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_other_pis_product"
            );
          this.component.sale.value_pis_st_total =
            this.calc_value_tribute_itens(itens_venda, "value_pis_st_product");
          // Usar o novo serviço para cálculos de ICMS Simples Nacional
          this.component.sale.value_icms_total =
            IcmsSimplesService.calculateIcmsTotal(itens_venda, enterprise);
          this.component.sale.value_credit_icms_simples =
            IcmsSimplesService.calculateCreditoIcmsSimples(
              itens_venda,
              enterprise
            );
          this.component.sale.value_pis_total = this.calc_value_tribute_itens(
            itens_venda,
            "value_pis_product"
          );
          this.component.sale.value_cofins_total =
            this.calc_value_tribute_itens(itens_venda, "value_cofins_product");

          this.component.sale.value_other_cofins_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_other_cofins_product"
            );
          this.component.sale.value_cofins_st_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_cofins_st_product"
            );

          // Novos campos IBS/CBS - Somar valores dos itens para o sales
          this.component.sale.value_base_tax_selective_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_tax_selective_prod"
            );
          this.component.sale.value_tax_selective_total =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_tax_selective_prod"
            );
          this.component.sale.value_total_tax_uf =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_total_tax_uf_prod"
            );
          this.component.sale.value_total_tax_mun =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_total_tax_mun_prod"
            );
          this.component.sale.value_total_ibs = this.calc_value_tribute_itens(
            itens_venda,
            "value_total_ibs_prod"
          );
          this.component.sale.value_total_cred_presumid =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_total_cred_presumid_prod"
            );
          this.component.sale.value_deferimento = this.calc_value_tribute_itens(
            itens_venda,
            "value_deferimento_prod"
          );
          this.component.sale.value_total_returns =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_total_returns_prod"
            );
          this.component.sale.value_exemption = this.calc_value_tribute_itens(
            itens_venda,
            "value_exemption_prod"
          );
          this.component.sale.value_cbs_total = this.calc_value_tribute_itens(
            itens_venda,
            "value_cbs_total_prod"
          );
          this.component.sale.value_base_total_cbs_mono =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_base_total_cbs_mono_prod"
            );
          this.component.sale.value_total_cbs_mono =
            this.calc_value_tribute_itens(
              itens_venda,
              "value_total_cbs_mono_prod"
            );
        }
      } catch (error) {
        alert(error);
      }
    },

    onConfirmFinalize() {
      this.dialogConfirm = false;
      this.finish_sale();
    },

    async finish_sale() {
      this.isloading = true;
      this.title = "Finalizando Venda";
      this.dialog_load = !this.dialog_load;

      const user = { ...this["auth/getUser"].user };
      await this.calc_tribute_finish_sale();

      let sale = { ...this.component.sale };
      sale.data_sale = new Date();
      sale.enterprise_id = this.getEnterprises.data[0].id;
      sale.user_id = user.id;

      this.title = "Processando venda";
      this.status = "Obtendo sequencia nfce";
      await this.getSequenceEmitterNfce(sale);
      if (this.invoiceType === INVOICE_TYPE.NFE) {
        sale.note_models_id = this.nfeNoteModel?.id || null;
      } else {
        sale.note_models_id = this.nfceNoteModel?.id || null;
      }

      if (!sale.note_models_id && this.invoiceType !== INVOICE_TYPE.ORCAMENTO) {
        this.dialog_load = false;
        this.isloading = false;
        this.titleError = "Modelo de nota não encontrado para este PDV";
        this.listErrors = ["Configure um modelo de nota (NFC-e ou NF-e) para este PDV na retaguarda."];
        this.dialog_alert = true;
        return;
      }

      await this.calculeBillsToReceiveOfSale(sale);

      // ── Orçamento: branch antes de criar venda ────────────────────
      if (this.invoiceType === INVOICE_TYPE.ORCAMENTO) {
        await this.createBudgetFromSale(sale);
        return;
      }

      this.title = "Gravando Venda";
      this.status = "Gravando nota na retaguarda";
      sale.access_key = "0000000000";
      sale.authorization_protocol = "000000000";
      sale.itens_sales = this.mounterCodeItem(this.getCart);
      sale.value_total_note = parseFloat(
        this.finalValueWithAdjustments
      ).toFixed(2);
      sale.value_payment_adjustment_total = parseFloat(
        this.totalAdjustments
      ).toFixed(2);
      sale.billstoReceive = { ...this.billstoReceive };

      const saleEmitterNFce = { ...sale };
      sale.data_sale = await this.mounterDateSales();

      const saleCreateCallBack = await this.createSalesBackOffice(sale);
      sale.id = saleCreateCallBack.id;
      sale.data_sale = saleEmitterNFce.data_sale;
      sale.number_sale = saleCreateCallBack.number_sale;
      sale.series = saleCreateCallBack.series;
      sale.note_models_id = saleCreateCallBack.note_models_id;

      const formPaymentsSnapshot = [...(sale.form_of_payments || [])];

      if (this.invoiceType === INVOICE_TYPE.NFE) {
        await this.emitterNfeSefaz(sale, saleCreateCallBack);
      } else {
        await this.emitterNfceSefaz(sale, saleCreateCallBack);
      }
      this.dialog_load = !this.dialog_load;

      this.checkDownloadExchange({ form_of_payments: formPaymentsSnapshot });

      if (this.saleSuccess) {
        this.openPrintPermissonDialog();
      }

      this.$store.dispatch(CLEAN_CART);
      this.table = [];
      this.$store.dispatch(GET_ALL_PRODUCT_BY_STATUS, {
        page: 1,
        limit: 10,
        paginete: true,
      });
      this.form_of_payments = {};
      this.new_pay = {};
      this.totalAdjustments = 0;
      this.activeTime = false;
      clearInterval(this.contador);
      this.component.loyaltyDiscount = 0;
      this.component.loyaltyPointsUsed = 0;
    },

    async getSequenceEmitterNfce(sale) {
      sale.number_sale = null;
      sale.series = null;
      sale.note_models_id = null;
      return sale;
    },
    async calculeBillsToReceiveOfSale(sale) {
      sale.form_of_payments = [];
      this.table.forEach((e) => {
        let dueDateBillstoReceive = this.calculeCashPayment(e, sale);
        this.billstoReceive.push(dueDateBillstoReceive);
        let form = Object();
        form.form_of_payment_id = e.form.id;
        form.code = e.form.code;
        form.payment_term_id = e.condition.id;
        form.value_form_payment = e.value_form_payment;
        sale.form_of_payments.push(form);
        form = {};
      });
    },

    async createSalesBackOffice(sale) {
      let saleCreateCallBack = {};
      await this.$store
        .dispatch(ADD_SALES_WITH_UPDATE_SEQUENCE, sale)
        .then((data) => {
          saleCreateCallBack = { ...data.data };
          this.addSalesProcess = true;
          this.isloading = false;
        })
        .catch((error) => {
          this.addSalesProcess = false;
          this.title = "Erro ao salvar vendas";
          this.status = "Verificar em Notas Emitidas";
          this.dialog_load = !this.dialog_load;
          this.component.dialog_finish = !this.component.dialog_finish;
          this.titleError = error.code + " - " + "Error ao salvar  venda";
        });

      return saleCreateCallBack;
    },
    async emitterNfceSefaz(sale, saleCreateCallBack) {
      const CONTIGENCY_IS_ACTIVE = true;
      let saleEmitterNFce = { ...sale };
      this.title = "Emitindo NFce - ";
      this.status = "Processando nota na sefaz";
      this.initCont();
      this.activeTime = true;
      await this.$store
        .dispatch(ISSUE_OF_INVOICE_NFCE, saleEmitterNFce)
        .then(async (response) => {
          sale.access_key = response.response.data.nfce.key;
          sale.status = response.response.data.nfce.status;
          if (sale.status === "Autorizada") {
            this.title = "NFCE processada";
            sale.number_sale = response.response.data.nfce.numberNfe;
            sale.authorization_protocol =
              response.response.data.nfce.numberProtocol;
            sale.series = response.response.data.nfce.seriesDocumentSupervisior;
            this.status = "Imprimindo Danfe";
            this.nfcePrint = response.response.data.nfcepdf;
            sale.id = saleCreateCallBack.id;
            sale.data_sale = saleCreateCallBack.data_sale;
            this.$store.dispatch(UPDATE_SALES, sale);
            this.saleSuccess = true;
            await this.processLoyaltyPointsRedemption(sale);
          } else if (sale.status === "Assinada") {
            this.title = "NFCE processada";
            sale.number_sale = response.response.data.nfce.numberNfe;
            sale.authorization_protocol = "000000000";
            sale.series = response.response.data.nfce.seriesDocumentSupervisior;
            this.status = "Imprimindo Danfe";
            this.nfcePrint = response.response.data.nfcepdf;
            sale.id = saleCreateCallBack.id;
            sale.data_sale = saleCreateCallBack.data_sale;
            this.$store.dispatch(UPDATE_SALES, sale);
            this.saleSuccess = true;
            await this.processLoyaltyPointsRedemption(sale);
          } else {
            this.title = "Erro  na Emissão NFCE";
            this.status = "Verificar em Notas Emitidas";
            sale.number_sale = response.response.data.nfce.numberNfe;
            sale.authorization_protocol = "000000000";
            sale.series = response.response.data.nfce.seriesDocumentSupervisior;
            sale.id = saleCreateCallBack.id;
            sale.data_sale = saleCreateCallBack.data_sale;
            this.$store.dispatch(UPDATE_SALES, sale);
            this.dialog_load = !this.dialog_load;
            this.component.dialog_finish = !this.component.dialog_finish;
          }
          //   if (this.getContigencyIsActive == CONTIGENCY_IS_ACTIVE){
          //      this.desativeContigency(saleEmitterNFce)
          //  }
        })
        .catch((error) => {
          this.activeTime = false;
          clearInterval(this.contador);
          // this.title = "Erro  na Emissão NFCE";
          // this.status = "Verificar em Notas Emitidas";

          this.activeOrEmitterNfceInContigencySefaz(
            error,
            saleEmitterNFce,
            saleCreateCallBack
          );
          this.component.dialog_finish = !this.component.dialog_finish;
          this.$store.dispatch(CLEAN_CART);
          (this.table = []),
            this.$store.dispatch(GET_ALL_PRODUCT_BY_STATUS, {
              page: 1,
              limit: 10,
              paginete: true,
            });
          sale.form_of_payments = [];
          this.form_of_payments = {};
          sale = {};
          this.new_pay = {};
          this.totalAdjustments = 0;
          this.dialog_load = !this.dialog_load;

          // Limpar dados de fidelidade
          this.component.loyaltyDiscount = 0;
          this.component.loyaltyPointsUsed = 0;
        });
    },

    async emitterNfeSefaz(sale, saleCreateCallBack) {
      let saleEmitterNFe = { ...sale };
      this.title = "Emitindo NF-e";
      this.status = "Processando nota na SEFAZ";
      this.initCont();
      this.activeTime = true;
      await this.$store
        .dispatch(ISSUE_OF_INVOICE_NFE, saleEmitterNFe)
        .then(async (response) => {
          sale.access_key = response.response.data.nfe.key;
          sale.status = response.response.data.nfe.status;
          if (sale.status === "Autorizada") {
            this.title = "NF-e processada";
            sale.number_sale = response.response.data.nfe.numberNfe;
            sale.authorization_protocol =
              response.response.data.nfe.numberProtocol || "000000000";
            sale.series = response.response.data.nfe.seriesDocumentSupervisior;
            this.status = "Imprimindo DANFE";
            this.nfcePrint = response.response.data.nfepdf;
            sale.id = saleCreateCallBack.id;
            sale.data_sale = saleCreateCallBack.data_sale;
            this.$store.dispatch(UPDATE_SALES, sale);
            this.saleSuccess = true;
            await this.processLoyaltyPointsRedemption(sale);
          } else {
            this.title = "Erro na Emissão NF-e";
            this.status = "Verificar em Notas Emitidas";
            sale.number_sale = response.response.data.nfe.numberNfe;
            sale.authorization_protocol = "000000000";
            sale.series = response.response.data.nfe.seriesDocumentSupervisior;
            sale.id = saleCreateCallBack.id;
            sale.data_sale = saleCreateCallBack.data_sale;
            this.$store.dispatch(UPDATE_SALES, sale);
            this.dialog_load = !this.dialog_load;
            this.component.dialog_finish = !this.component.dialog_finish;
          }
        })
        .catch((error) => {
          this.activeTime = false;
          clearInterval(this.contador);
          this.title = "Erro na Emissão NF-e";
          this.status = "Verificar em Notas Emitidas";
          this.component.dialog_finish = !this.component.dialog_finish;
          this.$store.dispatch(CLEAN_CART);
          this.table = [];
          this.$store.dispatch(GET_ALL_PRODUCT_BY_STATUS, {
            page: 1,
            limit: 10,
            paginete: true,
          });
          sale.form_of_payments = [];
          this.form_of_payments = {};
          sale = {};
          this.new_pay = {};
          this.totalAdjustments = 0;
          this.dialog_load = !this.dialog_load;
          this.component.loyaltyDiscount = 0;
          this.component.loyaltyPointsUsed = 0;
        });
    },

    async activeOrEmitterNfceInContigencySefaz(
      error,
      saleContigency,
      saleCreateCallBack
    ) {
      let codeStatusSefaz = error.error.response.status;
      let messsageStatusSefaz = error.error.response.data[0];
      const CODE_ERROR_SEFAZ = 400;
      const MESSAGE_ERROR_SEFAZ = "Erro ao enviar o xml assinado para sefaz";
      const CONTIGENCY_IS_ACTIVE = true;
      const CONTIGENCY_IS_NOT_ACTIVE = false;

      if (
        codeStatusSefaz === CODE_ERROR_SEFAZ &&
        messsageStatusSefaz === MESSAGE_ERROR_SEFAZ
      ) {
        if (this.getContigencyIsActive == CONTIGENCY_IS_ACTIVE) {
          await this.emitterNfceProcessContigency(
            saleContigency,
            saleCreateCallBack
          );
        } else this.getContigencyIsActive == CONTIGENCY_IS_NOT_ACTIVE;
        await this.activeContigencyNFce(saleContigency.number_sale);
        await this.emitterNfceProcessContigency(
          saleContigency,
          saleCreateCallBack
        );
      }
    },

    async emitterNfceProcessContigency(salesContigency, saleCreateCallBack) {
      await this.$store
        .dispatch(GET_SEQUENCE_NFCE, {
          enterprise_id: salesContigency.enterprise_id,
          typeNoteModel: "NFC-e",
        })
        .then((response) => {
          this.status = "Processando NFce em contigencia";
          let sequenceNFce = response.data[0];
          salesContigency.number_sale = sequenceNFce.sequence;
          salesContigency.series = sequenceNFce.series;
        });
      const response = await this.$store.dispatch(
        ISSUE_OF_INVOICE_NFCE,
        salesContigency
      );

      this.title = "Emitindo Nfce - Em contigência";
      this.status = "Processando nota na sefaz";
      // salesContigency.id = sale_id
      salesContigency.access_key = response.response.data.nfce.key;
      salesContigency.status = response.response.data.nfce.status;
      if (salesContigency.status === "Autorizada") {
        this.title = "NFCE processada";
        salesContigency.number_sale = response.response.data.nfce.numberNfe;
        salesContigency.authorization_protocol =
          response.response.data.nfce.numberProtocol;
        salesContigency.series =
          response.response.data.nfce.seriesDocumentSupervisior;
        this.status = "Imprimindo Danfe";
        this.nfcePrint = response.response.data.nfcepdf;
        salesContigency.id = saleCreateCallBack.id;
        salesContigency.data_sale = saleCreateCallBack.data_sale;
        this.$store.dispatch(UPDATE_SALES, salesContigency);
        this.saleSuccess = true;
        await this.processLoyaltyPointsRedemption(salesContigency);

        if (this.saleSuccess) {
          this.openPrintPermissonDialog();
        }

        // window.open(this.nfcePrint);
      } else {
        this.title = "Erro  na Emissão NFCE";
        this.status = "Verificar em Notas Emitidas";
        salesContigency.number_sale = response.response.data.nfce.numberNfe;
        salesContigency.authorization_protocol = "000000000";
        salesContigency.series =
          response.response.data.nfce.seriesDocumentSupervisior;
        salesContigency.id = saleCreateCallBack.id;
        salesContigency.data_sale = saleCreateCallBack.data_sale;
        this.$store.dispatch(UPDATE_SALES, salesContigency);
        this.dialog_load = !this.dialog_load;
      }
    },
    async activeContigencyNFce(sequenceId) {
      let contigencyObject = {
        status: "active",
        is_manual: false,
        typeContigency: "OFF-LINE",
        date_and_hours_contigency: this.mounterDateAndHoursContigency(),
        justification_on_contigency: "Queda de comunicação com a sefaz",
        contigency_initial_sequence: String(sequenceId),
        cnpj_emitter: this.getEnterprises.data[0].cnpj,
      };
      this.$store.dispatch(ACTIVE_CONTIGENCY, contigencyObject);
    },
    async desativeContigency(sale) {
      let payload = {
        status: "finished",
        cnpj_emitter: this.getEnterprises.data[0].cnpj,
        date_and_hours_finished_contigency:
          this.mounterDateAndHoursContigency(),
        contigency_finished_sequence: sale.numberNfe,
      };
      await this.$store.dispatch(DESATIVE_CONTIGENCY_NFCE, payload);
    },

    printNfcePdf() {
      this.dialog_nfce = !this.dialog_nfce;
    },

    initCont() {
      this.time = 30;
      this.contador = setInterval(() => {
        if (this.time > 0) this.time = this.time - 1;
        else if (this.time == 0) {
          clearInterval(this.contador);
        }
      }, 1000);
    },

    mounterDateAndHoursContigency() {
      return formatDateTimeForDatabase(new Date());
    },

    checkDescontItensRecalculeValueSale(itens) {
      itens.forEach((itemProduct) => {
        let valueProductDescont = 0;
        if (itemProduct.value_descont_product != 0) {
          valueProductDescont =
            itemProduct.value_sale - itemProduct.value_descont_product;
          itemProduct.value_sale = valueProductDescont;
        }
      });
      return itens;
    },

    mounterCodeItem(itens) {
      let item = 0;
      itens.forEach(
        (product) => ((product.code_item = item), (item = item + 1))
      );
      item = 0;
      return itens;
    },
    mounterDateSales() {
      return formatDateForDatabase(new Date());
    },

    calculeCashPayment(payment, sales) {
      let BillsToReceive = [];
      const AVISTA = 0;
      let salesBillsToReceive = { ...sales };
      let paymentFormPayment = payment.condition.deadline;
      if (paymentFormPayment == AVISTA) {
        sales.paymentMethodIndicator = "0";
        BillsToReceive = this.mounterBillsToReceiveWithInCash(
          salesBillsToReceive.data_sale,
          salesBillsToReceive.number_sale,
          payment.value_form_payment,
          salesBillsToReceive.client_id,
          salesBillsToReceive.enterprise_id
        );
        return BillsToReceive;
      } else {
        let BillsToReceive = [];
        sales.paymentMethodIndicator = "1";
        BillsToReceive = this.mounterPaymentDeferredPayment(
          payment,
          salesBillsToReceive
        );
        return BillsToReceive;
      }
    },

    mounterPaymentDeferredPayment(payment, salesAttributes) {
      let deadline = payment.condition.deadline;
      let numberOfInstallmentsPaymentForm = payment.condition.amount;
      let valueTotalSales = payment.value_form_payment;
      let valuePaymentDebTotal = parseFloat(valueTotalSales).toFixed(2);
      let valueOfPortion = parseFloat(
        (valuePaymentDebTotal / numberOfInstallmentsPaymentForm).toFixed(2)
      );
      let calculeValueTotalPendingOfDivision =
        valueOfPortion * numberOfInstallmentsPaymentForm;

      let billstoReceiveArray = [];
      let portion = 1;
      let aux_deadline = deadline.split("/");
      let deadlineArray = aux_deadline.map((item) => parseInt(item));
      for (portion = 1; portion <= numberOfInstallmentsPaymentForm; portion++) {
        let billsToReceiveCalcule = this.mounterBillsToReceiveWithOnTerm(
          salesAttributes.data_sale,
          salesAttributes.number_sale,
          portion,
          deadlineArray[portion - 1],
          valueOfPortion,
          salesAttributes.enterprise_id,
          salesAttributes.client_id
        );
        billstoReceiveArray.push(billsToReceiveCalcule);
      }

      if (calculeValueTotalPendingOfDivision != valuePaymentDebTotal) {
        let remaining =
          valuePaymentDebTotal - calculeValueTotalPendingOfDivision;

        billstoReceiveArray = this.calculateDiferenceInValueBillstoReceive(
          billstoReceiveArray,
          remaining
        );
        return billstoReceiveArray;
      }

      return billstoReceiveArray;
    },

    calculateDiferenceInValueBillstoReceive(billstoReceiveArray, remaining) {
      for (let index = 0; index < billstoReceiveArray.length; index++) {
        let valueIndexLastInstallment = index + 1;
        if (valueIndexLastInstallment === billstoReceiveArray.length) {
          billstoReceiveArray[index].value_title =
            billstoReceiveArray[index].value_title + remaining;
          billstoReceiveArray[index].value_net =
            billstoReceiveArray[index].value_title;
          billstoReceiveArray[index].title_balance =
            billstoReceiveArray[index].value_title;
        }
      }
      return billstoReceiveArray;
    },

    mounterBillsToReceiveWithOnTerm(
      dateIssuanceDate,
      number_sale,
      portation,
      deadline = 0,
      valueOfPortion,
      enterprise_id,
      client_id
    ) {
      let dateIssuanceDateFormat = this.formatDateForDatabase(dateIssuanceDate);

      const STATUS_ABERTO = "ABERTO";
      const TYPE_TITLE = "RECEBIMENTO";
      let billstoReceiveInCash = {};
      billstoReceiveInCash.status = STATUS_ABERTO;
      billstoReceiveInCash.issuance_date = dateIssuanceDateFormat;
      billstoReceiveInCash.issuance_due =
        this.generateOfMaturityBillsToReceivce(
          dateIssuanceDate,
          deadline,
          portation
        );
      billstoReceiveInCash.type_title = TYPE_TITLE;
      billstoReceiveInCash.number_title = `${number_sale}/${portation}`;
      billstoReceiveInCash.value_title = valueOfPortion;
      billstoReceiveInCash.dejection = 0;
      billstoReceiveInCash.interest = 0;
      billstoReceiveInCash.value_net = valueOfPortion;
      billstoReceiveInCash.title_balance = valueOfPortion;
      billstoReceiveInCash.annotation = `Esse título e referente a venda ${number_sale}`;
      (billstoReceiveInCash.account_plans_id = 1),
        (billstoReceiveInCash.client_id = client_id),
        (billstoReceiveInCash.enterprise_id = enterprise_id),
        (billstoReceiveInCash.sale_id = null);
      return billstoReceiveInCash;
    },

    mounterBillsToReceiveWithInCash(
      issuanceDate,
      number_sale,
      value_total_note,
      client_id,
      enterprise_id
    ) {
      let billstoReceiveInCashArray = [];
      let issuanceDateFormat = this.formatDateForDatabase(issuanceDate);
      const STATUS_BAIXADO = "BAIXADO";
      const TITLE_TITULO = "DINHEIRO";
      let billstoReceiveInCash = {};
      billstoReceiveInCash.status = STATUS_BAIXADO;
      billstoReceiveInCash.issuance_date = issuanceDateFormat;
      billstoReceiveInCash.issuance_due = issuanceDateFormat;
      billstoReceiveInCash.type_title = TITLE_TITULO;
      billstoReceiveInCash.number_title = `${number_sale}/${1}`;
      billstoReceiveInCash.value_title = value_total_note;
      billstoReceiveInCash.dejection = 0;
      billstoReceiveInCash.interest = 0;
      billstoReceiveInCash.value_net = 0;
      billstoReceiveInCash.title_balance = 0;
      billstoReceiveInCash.annotation = `Esse título e referente a venda ${number_sale}`;
      (billstoReceiveInCash.account_plans_id = 1),
        (billstoReceiveInCash.client_id = client_id),
        (billstoReceiveInCash.enterprise_id = enterprise_id),
        (billstoReceiveInCash.sale_id = null);

      billstoReceiveInCashArray.push(billstoReceiveInCash);
      return billstoReceiveInCashArray;
    },

    generateOfMaturityBillsToReceivce(dateReceive, deadline) {
      let dateNew = new Date(dateReceive);
      dateNew.setDate(dateNew.getDate() + deadline);
      return this.formatDateForDatabase(dateNew);
    },

    formatDateForDatabase,
    formatDateForISO,

    async GetFormPay() {
      await this.$store.dispatch(GET_ALL_FORM_OF_PAYMENT, {
        page: 1,
        limit: 100,
      });
    },
    async GetPayTerms() {
      await this.$store.dispatch(GET_ALL_PAYMENT_TERM, {
        page: 1,
        limit: 100,
      });
    },
    form_verify(val) {
      let string = val.toLowerCase();
      if (string === "DINHEIRO") {
        this.items_payTerm.forEach((e) => {
          let description = e.description.replace(/\s/g, "").toLowerCase();
          if (description === "AVISTA") {
            this.form_of_payments.condition = e;
            this.validCondition = true;
          }
        });
      } else {
        this.validCondition = false;
      }
    },
    setPaymentTerm(form_of_payment_id, paymentterm) {
      this.items_payTerm = [];
      paymentterm.map((element) => {
        if (element.form_of_payment_id === form_of_payment_id) {
          this.items_payTerm.push(element);
        }
      });
      paymentterm = [];
    },

    openPrintPermissonDialog() {
      this.dialogPermissionPrint = true;
    },

    cancelExchangeCredit() {
      this.exchangeDialog = false;
      this.validValue = false;
      this.idCreditExchange = null;
      this.pendingCreditoPay = null;
      this.codeCupomSearch = "";
      this.form_of_payments = {
        code: String(),
        form: String(),
        condition: String(),
        value_form_payment: null,
      };
    },

    checkDownloadExchange(saleData) {
      for (let i = 0; i < saleData.form_of_payments.length; i++) {
        if (
          saleData.form_of_payments[i].code ==
          this.FORM_OF_PAYMENT_CODE.CREDITO_LOJA
        ) {
          const payload = {
            enterprise_id: this.component.sale.enterprise_id,
            billstopay_id: this.idCreditExchange,
            value_used: parseFloat(
              saleData.form_of_payments[i].value_form_payment
            ),
          };
          this.$store.dispatch(DOWNLOAD_CREDIT, payload);
        }
      }
    },

    async processLoyaltyPointsRedemption(sale) {
      if (!sale.client_id) {
        return;
      }

      const loyaltyPointsUsed =
        sale.loyalty_points_used || this.component.loyaltyPointsUsed || 0;

      if (loyaltyPointsUsed > 0) {
        try {
          this.status = "Processando resgate de pontos de fidelidade";

          const loyaltyPayload = {
            client_id: sale.client_id,
            enterprise_id: sale.enterprise_id,
            points_to_use: loyaltyPointsUsed,
            sale_id: sale.id,
          };

          await this.$store.dispatch(REDEEM_LOYALTY_POINTS, loyaltyPayload);
        } catch (error) {}
      }
    },

    getConditionLabel(item) {
      if (!item || !item.description) {
        return "";
      }

      const adjustment = this.getActiveAdjustmentForEnterprise(item);

      if (!adjustment) {
        return item.description;
      }

      const adjustmentValue = adjustment.discount || adjustment.addition;
      const adjustmentType =
        adjustment.adjustment_type === "PERCENT" ? "%" : "R$";
      const isDiscount = !!adjustment.discount;

      if (adjustmentType === "%") {
        return `${item.description} (${
          isDiscount ? "Desc." : "Acrés."
        } ${adjustmentValue}%)`;
      } else {
        return `${item.description} (${
          isDiscount ? "Desc." : "Acrés."
        } R$ ${adjustmentValue})`;
      }
    },

    getActiveAdjustmentForEnterprise(paymentCondition) {
      if (
        !paymentCondition ||
        !paymentCondition.adjustments ||
        paymentCondition.adjustments.length === 0
      ) {
        return null;
      }

      const enterpriseId = this.getEnterprises.data[0].id;

      const validAdjustments = paymentCondition.adjustments.filter((adj) => {
        return adj.enterprise_id === enterpriseId && adj.is_active;
      });

      if (validAdjustments.length === 0) {
        return null;
      }

      return validAdjustments.sort((a, b) => a.priority - b.priority)[0];
    },

    calculateAdjustmentValue(baseValue, adjustment) {
      if (!adjustment) {
        return 0;
      }

      const adjustmentValue = adjustment.discount || adjustment.addition;

      if (!adjustmentValue) {
        return 0;
      }

      let calculatedAdjustment = 0;

      if (adjustment.adjustment_type === "PERCENT") {
        calculatedAdjustment = baseValue * (adjustmentValue / 100);
      } else {
        calculatedAdjustment = adjustmentValue;
      }

      return adjustment.discount
        ? -Math.abs(calculatedAdjustment)
        : Math.abs(calculatedAdjustment);
    },

    applyPaymentTermAdjustment(paymentCondition, baseValue) {
      const adjustment =
        this.getActiveAdjustmentForEnterprise(paymentCondition);

      if (!adjustment) {
        return baseValue;
      }

      const adjustmentValue = this.calculateAdjustmentValue(
        baseValue,
        adjustment
      );
      const finalValue = parseFloat(baseValue) + adjustmentValue;

      return finalValue > 0 ? finalValue : 0;
    },

    async loadNoteModels() {
      const enterpriseId = this.getEnterprises?.data?.[0]?.id
                        || this.component?.sale?.enterprise_id;
      const pdvId = this.component?.sale?.pdv_id;
      if (!enterpriseId || !pdvId) return;
      try {
        const response = await this.$store.dispatch(GET_NOTE_MODELS_BY_PDV, {
          enterprise_id: enterpriseId,
          pdv_id: pdvId,
        });
        const models = response?.data?.data || response?.data || [];
        const list = Array.isArray(models) ? models : Object.values(models).filter(v => v && v.id);
        this.nfceNoteModel = list.find(m => m.tax_document_type === NOTE_MODEL_TYPE.NFCE) || null;
        this.nfeNoteModel  = list.find(m => m.tax_document_type === NOTE_MODEL_TYPE.NFE)  || null;
        this.orcNoteModel  = list.find(m => m.tax_document_type === NOTE_MODEL_TYPE.ORCAMENTO) || null;
      } catch (_) {}
    },

    async createBudgetFromSale(sale) {
      if (!this.orcNoteModel?.id) {
        this.dialog_load = false;
        this.isloading = false;
        this.titleError = "Modelo de orçamento não encontrado para este PDV";
        this.listErrors = ["Configure um modelo de nota (ORC) para este PDV na retaguarda."];
        this.dialog_alert = true;
        return;
      }
      try {
        const enterprise = this.getEnterprises.data[0];
        const user = { ...this["auth/getUser"].user };
        const cart = this.getCart;
        const budgetItems = cart.map((item, i) => ({
          code_item:                  String(i + 1),
          product_id:                 item.product_id,
          amount:                     item.amount,
          value_budget_product:       item.value_sale,
          value_subtotal_product:     item.value_subtotal_product,
          discount_amount:            item.value_descont_product      || 0,
          value_accounting_product:   item.value_accounting_product   || 0,
          description_item:           item.description,
          cfop_id:                    item.cfop_id,
          cst_id:                     item.cst_id,
          csosn_id:                   item.csosn_id,
          cst_ipi_id:                 item.product?.cst_ipi_id || item.cst_ipi?.id || item.cst_ipi || null,
          cst_pis_id:                 item.cst_pis_id,
          cst_cofins_id:              item.cst_cofins_id,
          value_base_icms_product:    item.value_base_icms_product    || 0,
          value_icms_product:         item.value_icms_product         || 0,
          value_icms_free_product:    item.value_free_icms_product    || 0,
          value_icms_outher_product:  item.value_icms_outher_product  || 0,
          type_of_operation:          "CREATE",
        }));

        const paymentMethods = this.table.map((p) => ({
          form_of_payment_id: p.form.id,
          payment_term_id: p.condition.id,
          value_form_payment: p.value_form_payment,
          type_of_operation: "CREATE",
        }));

        const totalProducts = cart.reduce(
          (a, b) => a + parseFloat(b.value_subtotal_product || 0),
          0
        );
        const totalDiscount = cart.reduce(
          (a, b) => a + parseFloat(b.value_descont_product || 0),
          0
        );

        const payload = {
          client_id: sale.client_id,
          seller_id: sale.seller_id,
          enterprise_id: enterprise.id,
          user_id: user.id,
          note_models_id:         this.orcNoteModel?.id,
          number_budget:          String((this.orcNoteModel?.sequence || 0) + 1),
          tax_operation_types_id: sale.tax_operation_types_id || 2,
          status:                 "Em andamento",
          date_budget: new Date().toISOString().split("T")[0],
          anotations: null,
          valor_products_total: totalProducts.toFixed(2),
          value_descont_total: totalDiscount.toFixed(2),
          value_total_note: parseFloat(this.finalValueWithAdjustments).toFixed(
            2
          ),
          value_account_total: cart
            .reduce(
              (a, b) => a + parseFloat(b.value_accounting_product || 0),
              0
            )
            .toFixed(2),
          value_icms_total: cart
            .reduce((a, b) => a + parseFloat(b.value_icms_product || 0), 0)
            .toFixed(2),
          budget_items: budgetItems,
          budgetPaymentMethod: paymentMethods,
        };

        const token = localStorage.getItem("token_gestao");
        const { data: budget } = await axiosautomacao.post("budgets", payload, {
          headers: { Authorization: "Bearer " + token },
        });

        budget.budget_items = budgetItems;
        budget.budgetPaymentMethod = paymentMethods.map((p, i) => ({
          ...p,
          form_of_payment_description: this.table[i].form.description,
        }));

        const clientName =
          sale.client?.physicalpeople?.name ||
          sale.client?.legalpeople?.fantasyName ||
          "";
        const sellerName = sale.seller?.physicalpeople?.name || "";

        this.printBudgetPdf(enterprise, budget, clientName, sellerName);

        this.$store.dispatch(CLEAN_CART);
        this.table = [];
        this.form_of_payments = {};
        this.invoiceType = INVOICE_TYPE.NFCE;
        this.isloading = false;
        this.dialog_load = false;
        this.component.dialog_finish = false;
      } catch (error) {
        this.isloading = false;
        this.dialog_load = false;
        this.titleError = "Erro ao gerar orçamento";
        this.listErrors = [
          {
            text:
              error.response?.data?.message ||
              error.message ||
              "Tente novamente.",
          },
        ];
        this.dialog_alert = true;
      }
    },

    printBudgetPdf(enterprise, budget, client, seller) {
      const user = { ...this["auth/getUser"].user };
      const now = new Date();

      const d = new Date(budget.date_budget);
      const fmt = (n) => String(n).padStart(2, "0");
      const formatedDate = `${fmt(d.getDate())}/${fmt(
        d.getMonth() + 1
      )}/${d.getFullYear()}`;

      const productColumns = [
        { title: "Nome", dataKey: "description_item" },
        { title: "Qtd", dataKey: "amount" },
        { title: "Unit", dataKey: "value_accounting_product" },
        { title: "Desc", dataKey: "discount_amount" },
        { title: "Subt", dataKey: "value_budget_product" },
      ];
      const paymentColumns = [
        { title: "Forma", dataKey: "form_of_payment_description" },
        { title: "Valor", dataKey: "value_form_payment" },
      ];

      import("jspdf").then(({ default: jsPDF }) => {
        import("jspdf-autotable").then(() => {
          const doc = new jsPDF({ unit: "mm", format: [80, 40] });

          doc.setLineWidth(0.1);
          doc.setFontSize(2);
          doc.text(`Usuário: ${user.name}`, 2, 1);
          doc.text(now.toLocaleString(), 2, 2);

          doc.setFontSize(3);
          doc.line(2, 3, 38, 3);
          doc.text(enterprise?.name || "", 8, 5);
          doc.setFontSize(2);
          doc.text(`Fantasia: ${enterprise?.fantasyName || ""}`, 2, 7);
          doc.text(
            `${enterprise?.address?.street || ""}, ${
              enterprise?.address?.number || ""
            }`,
            2,
            8
          );
          doc.text(
            `${enterprise?.address?.city || ""} - ${
              enterprise?.address?.state || ""
            }`,
            2,
            9
          );

          doc.line(2, 10, 38, 10);
          doc.setFontSize(3);
          doc.text(`ORÇAMENTO ${(budget.status || "").toUpperCase()}`, 13, 12);
          doc.text(
            `Data: ${formatedDate}   Nº: ${budget.number_budget || ""}`,
            2,
            15
          );
          doc.text(`Vendedor: ${seller}`, 2, 18);
          doc.text(`Cliente: ${client}`, 2, 21);
          doc.text(`Total: R$ ${budget.value_total_note}`, 2, 24);

          doc.line(2, 26, 38, 26);
          doc.setFontSize(3);
          doc.text("PRODUTOS", 16, 28);

          const tblCfg = {
            headStyles: { fillColor: [230, 230, 230], textColor: [54, 54, 54] },
            margin: { top: 2, right: 1, left: 1 },
            theme: "grid",
            styles: { cellWidth: "wrap", cellPadding: 1, fontSize: 1.8 },
          };

          doc.autoTable(productColumns, budget.budget_items, {
            ...tblCfg,
            startY: 29,
          });

          const afterProd = doc.lastAutoTable.finalY;
          doc.line(2, afterProd + 3, 38, afterProd + 3);
          doc.setFontSize(3);
          doc.text("FORMAS DE PAGAMENTO", 12, afterProd + 7);
          doc.autoTable(paymentColumns, budget.budgetPaymentMethod, {
            ...tblCfg,
            startY: afterProd + 8,
          });

          window.open(URL.createObjectURL(doc.output("blob")), "_blank");
        });
      });
    },
  },

  updated() {
    this.value_pay(this.table);
    this.value_remain();
  },
  watch: {
    items: function () {
      this.register(this.items);
    },
    getFormOfPayment: function (val) {
      this.items_formPay = Object.values(val.data);
    },
    getPaymentTerms: function (val) {
      this.items_payTerm = Object.values(val.data);
    },
    "form_of_payments.form": function (val) {
      this.currentAdjustment = null;
      this.setPaymentTerm(val.id, this.getPaymentTerms.data);
      this.form_verify(val.description);
      if (val.code == this.FORM_OF_PAYMENT_CODE.CREDITO_LOJA) {
        this.validValue = false;
        this.idCreditExchange = null;
        this.pendingCreditoPay = null;
        this.form_of_payments.condition = this.items_payTerm[0];
      } else {
        this.validValue = false;
      }
    },

    "form_of_payments.condition": function (paymentCondition) {
      if (!paymentCondition || !this.total_remain) {
        this.currentAdjustment = null;
        return;
      }

      const baseValue = this.total_remain;
      const adjustment =
        this.getActiveAdjustmentForEnterprise(paymentCondition);
      const adjustedValue = this.applyPaymentTermAdjustment(
        paymentCondition,
        baseValue
      );

      if (adjustedValue !== baseValue && adjustment) {
        const adjustmentValue = adjustment.discount || adjustment.addition;
        const adjustmentType = adjustment.discount ? "DISCOUNT" : "ADDITION";
        const calculatedAdjustment = this.calculateAdjustmentValue(
          baseValue,
          adjustment
        );

        this.currentAdjustment = {
          type: adjustmentType,
          adjustment_type: adjustment.adjustment_type,
          value: adjustmentValue,
          originalValue: baseValue.toFixed(2),
          finalValue: adjustedValue.toFixed(2),
          difference: Math.abs(adjustedValue - baseValue).toFixed(2),
          calculatedValue: calculatedAdjustment,
        };
      } else {
        this.currentAdjustment = null;
      }
    },

    "form_of_payments.value_form_payment": function (value) {
      value = value.replace(/\D/g, "");
      if (value.length == 1) {
        value = value.padStart(3, "0");
      }
      value = value.slice(0, -2) + "." + value.slice(-2);
      value = value.replace(/^0+(\d)/, "$1");
      this.form_of_payments.value_form_payment = value;
    },
  },

  computed: {
    ...mapGetters([
      "getCart",
      "getClientSales",
      "getFormOfPayment",
      "getPaymentTerms",
      "getSequenceNfce",
      "getEnterprises",
      "getIsAuthFiscal",
      "auth/getUser",
      "getContigencyIsActive",
    ]),

    confirmTypeLabel() {
      if (this.invoiceType === INVOICE_TYPE.ORCAMENTO) return this.orcNoteModel?.description || 'Orçamento';
      if (this.invoiceType === INVOICE_TYPE.NFE)       return 'NF-e';
      return 'NFC-e';
    },
    confirmIconColor() {
      if (this.invoiceType === INVOICE_TYPE.ORCAMENTO) return 'orange darken-2';
      if (this.invoiceType === INVOICE_TYPE.NFE)       return 'blue darken-2';
      return 'green darken-2';
    },
    confirmIcon() {
      if (this.invoiceType === INVOICE_TYPE.ORCAMENTO) return 'mdi-file-document-outline';
      if (this.invoiceType === INVOICE_TYPE.NFE)       return 'mdi-description';
      return 'mdi-receipt';
    },

    isLegalPeopleClient() {
      const client = this.component.sale?.client;
      return (
        client &&
        client.id !== 1 &&
        client.legalpeople !== null &&
        client.legalpeople !== undefined
      );
    },

    finalValueWithAdjustments() {
      const loyaltyDiscount = parseFloat(
        this.component.loyaltyDiscount ||
          this.component.sale?.loyalty_discount ||
          0
      );
      const originalTotal =
        parseFloat(this.component.total || 0) - loyaltyDiscount;
      let currentAdjustmentValue = 0;

      if (this.currentAdjustment && this.currentAdjustment.calculatedValue) {
        currentAdjustmentValue = this.currentAdjustment.calculatedValue;
      }

      return Math.max(
        0,
        originalTotal + this.totalAdjustments + currentAdjustmentValue
      );
    },
  },
  async mounted() {
    await this.GetFormPay();
    await this.GetPayTerms();
    await this.loadNoteModels();
  },
};
</script>
<style scoped>
.valueFinal {
  font-weight: bold;
  font-size: 20px;
}

.titleValue {
  font-size: 15px;
}

.disable-events {
  pointer-events: none;
}
</style>
